// ── PC 중앙 패널 — 날짜순 (settlementdot/TimelineView 직접 사용) ─────────────────
// 모바일 정산서 날짜순 탭과 완전히 동일한 UI
// → 날짜순 디자인 변경 시 이쪽도 자동 반영 (단일 소스)

import React from 'react';
import { CENTER_PANEL, PANEL_TITLE, SCROLL, emptyTxt } from './pcStyles';
// 모바일 정산서 날짜순 컴포넌트 직접 import
import { TimelineView } from '../../employee/settlementdot/PayComponents';

export function PcCenterPanel({
  selectedUser,    // 선택된 마케터 객체
  dataLoading,     // 데이터 로딩 여부
  marketerData,    // { clients, unmatchedRevenue, summary }
  records,         // 정산지급 기록 배열
  unmTotal,        // 미연결 결제 건수 (뱃지용)
}) {
  const { clients, unmatchedRevenue } = marketerData;
  const cancelEvents = marketerData.cancelEvents || [];

  // TimelineView(settlementdot/buildTimeline)가 기대하는 키 포맷으로 변환
  // admin: cards/phones/deposits/cardUploads/others → settlementdot: card/phone/payments/card_upload/others
  const unmatched = {
    card:        unmatchedRevenue.cards       || [],
    card_upload: unmatchedRevenue.cardUploads || [],
    phone:       unmatchedRevenue.phones      || [],
    payments:    unmatchedRevenue.deposits    || [],
    others:      unmatchedRevenue.others      || [], // 기타 수입 (settlementdot buildTimeline이 처리)
    consultantCharges: unmatchedRevenue.consultantCharges || [],
  };
  const shareIncome = marketerData.consultantShareIncome || { items: [] };

  return (
    <div style={CENTER_PANEL}>

      {/* 패널 타이틀 */}
      <div style={{ ...PANEL_TITLE, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>날짜순</span>
        {unmTotal > 0 && (
          <span style={{
            fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 10,
            background: '#fee2e2', color: '#dc2626',
            textTransform: 'none', letterSpacing: 0,
          }}>
            미연결 {unmTotal}
          </span>
        )}
      </div>

      {/* 본문 */}
      <div style={SCROLL}>
        {!selectedUser ? (
          <div style={emptyTxt}>마케터를 선택하세요</div>
        ) : (
          // TimelineView가 loading·empty 처리 + buildTimeline 호출을 모두 담당
          <TimelineView
            clients={clients}
            unmatched={unmatched}
            records={records}
            cancelEvents={cancelEvents}
            loading={dataLoading}
            shareIncome={shareIncome}
            consultantChargeSummaryScope="admin"
          />
        )}
      </div>

    </div>
  );
}
